import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "isMarkdown", "truncate", "paragraphs", "className", "extra"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { truncateParagraphs } from './Content.utils';
import MarkdownContent from '../../components/MarkdownContent/MarkdownContent';
import { classNames } from '../../utils/classname';
var defaultProps = {
  children: null,
  content: null,
  isMarkdown: true,
  truncate: false,
  paragraphs: 2,
  className: '',
  extra: null
};
export default function ContentMarkup(_ref) {
  var children = _ref.children,
    content = _ref.content,
    isMarkdown = _ref.isMarkdown,
    truncate = _ref.truncate,
    paragraphs = _ref.paragraphs,
    className = _ref.className,
    extra = _ref.extra,
    gridColumnProps = _objectWithoutProperties(_ref, _excluded);
  var finalContent = content || children;
  if (_isEmpty(finalContent) && _isEmpty(extra)) {
    return null;
  }
  if (truncate) {
    finalContent = truncateParagraphs(finalContent, paragraphs);
  }
  var finalClassName = classNames(_defineProperty({
    'content-section-markup': true
  }, className, true));
  return /*#__PURE__*/React.createElement(Grid.Column, _extends({
    className: finalClassName
  }, gridColumnProps), isMarkdown && /*#__PURE__*/React.createElement(MarkdownContent, null, finalContent), !isMarkdown && finalContent, !_isEmpty(extra) && extra);
}
ContentMarkup.defaultProps = defaultProps;